const RedirectToSettings = () => (window.location.href = "/settings")

export default RedirectToSettings
